// extracted by mini-css-extract-plugin
module.exports = {"bookmarkCancelButton":"BookmarkDialog_bookmarkCancelButton__3rmEM","bookmarkConfirmButton":"BookmarkDialog_bookmarkConfirmButton__5Jt-s"};